import React from 'react';
import { ImageProps } from '.';

const SvgZexpressSymbolKor = ({ size = 102, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 5.1)) || 20} fill='none' viewBox='0 0 102 20' {...props}>
      <path
        fill='#6E52FF'
        d='M45.86 19.471h-2.682v-4.603H32.742v-2.135H45.86v6.738ZM82.66 19.471h-2.557V9.866h-1.718v8.727h-2.536V.7h2.536V7.69h1.718V.429h2.556v19.043Z'
      />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M92.916 12.691c4.15 0 6.622 1.235 6.643 3.411-.02 2.177-2.493 3.37-6.642 3.37-4.191 0-6.685-1.193-6.685-3.37 0-2.176 2.494-3.41 6.684-3.41Zm0 2.03c-2.66 0-3.981.44-3.96 1.381-.021.942 1.3 1.381 3.96 1.381 2.599 0 3.94-.439 3.961-1.38-.02-.942-1.362-1.382-3.96-1.382Z'
        clipRule='evenodd'
      />
      <path
        fill='#6E52FF'
        d='M53.898 17.002H64.48v2.135H51.194v-6.174h2.703v4.04ZM15.73 1.12c5.532-.088 10.02 3.4 10.02 8.572l-.014.477c-.268 4.906-4.647 8.177-10.007 8.09-1.025-.016-1.814-.14-2.926-.449-3.489-.971-10.354-5.116-12.687-6.841-.237-.175-.082-.527.217-.499l14.048 1.345c.215.021.34.238.235.415l-1.352 2.314c-.15.256.163.528.426.373l8.17-4.872a.407.407 0 0 0 0-.709l-8.17-4.871c-.263-.156-.576.116-.426.372l1.352 2.314c.101.177-.02.392-.235.413L.333 8.911c-.3.028-.451-.324-.217-.498C2.45 6.687 9.314 2.54 12.803 1.568c1.112-.308 1.901-.433 2.926-.449Z'
      />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M69.185 6.413h2.599v-4.29h2.472v12.828h-7.585V2.124h2.514v4.29Zm0 6.404h2.599v-4.31h-2.599v4.31Z'
        clipRule='evenodd'
      />
      <path
        fill='#6E52FF'
        d='M63.977 14.219h-2.682V.449h2.682v13.77ZM59.283 3.923h-3.835v.272c0 2.281 1.404 4.604 4.547 5.546l-1.362 2.092c-2.137-.67-3.646-2.04-4.505-3.766-.87 1.872-2.42 3.38-4.652 4.122l-1.383-2.092c3.164-1.026 4.631-3.495 4.631-5.902v-.272h-3.919V1.79h10.478v2.134ZM45.86 11.896h-2.682V.43h2.682v11.467ZM94.237 9.51h7.397v2.135H84.241V9.511h7.355V7.167h2.64V9.51ZM41.166 3.672h-3.834c.02 2.229 1.425 4.573 4.547 5.504l-1.362 2.072c-2.138-.66-3.646-2.03-4.506-3.767-.87 1.883-2.42 3.38-4.652 4.122l-1.383-2.071c3.143-1.015 4.61-3.485 4.631-5.86H30.69V1.538h10.477v2.134Z'
      />
      <path
        fill='#6E52FF'
        d='M94.279 1.37c0 2.218 2.137 4.332 6.433 4.855l-1.027 2.072c-3.216-.482-5.585-1.831-6.79-3.746-1.225 1.915-3.594 3.275-6.81 3.746l-.943-2.072c4.212-.523 6.412-2.7 6.412-4.855V.742h2.725v.628Z'
      />
    </svg>
  );
};

export default SvgZexpressSymbolKor;
